import { HttpContextToken } from '@angular/common/http';

export const BYPASS_RECAPTCHA_INTERCEPTOR = new HttpContextToken<boolean>(() => false);
